import React, { Component } from 'react'
import _ from 'lodash'
import { findDOMNode } from 'react-dom'
import ReactDataGrid from 'react-data-grid'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { createOrUpdateWeldsMutation, destroyWeldsMutation, toggleBlockWeldMutation, WeldsFetchQuery } from './mutations'
import { WeldInspectionGroupsQuery } from '../Projects/mutations'
import { compose, graphql } from 'react-apollo/index'
import ConfirmModal from '../Alerts/ConfirmModal'
import ValidationAlert from '../Alerts/ValidationAlert'
import WeldingLogModal from '../EventLog/WeldingLogModal'
import InspectionLogModal from '../EventLog/InspectionLogModal'
import componentWillReceiveProps from './helpers/WeldsDataGridComponentWillReceiveProps'
import prepareWelds from './helpers/WeldsDataGridPrepareWelds'
import multiLogsButtons from './helpers/multiLogsButtons'
import { Label, Input, Button } from 'reactstrap'
import getGridColumns from './helpers/getGridColumns'
import { getUserPermissions } from '../../utils/userPermissions'
// import {withGaEvent} from '../Support/GoogleAnalytics'
import BaseMaterialModal from '../Dictionary/BaseMaterialModal'
import '../../scss/WeldsDataGrid.css'
import WpsModal from './helpers/wps/WpsModal'
import WpsViewModal from './helpers/wps/WpsViewModal'
import InspectionCategoryModal from './helpers/wps/InspectionCategoryModal'
import WeldTypeModal from './helpers/wps/WeldTypeModal'
import { BlockWithLoader } from '../Support'
import { Row } from 'react-data-grid'
import { Toolbar } from 'react-data-grid-addons'

class WeldsDataGrid extends Component {
  constructor(props, context) {
    super(props, context)

    const parsedQuery = queryString.parse(props.history.location.search)
    let filtersFromUrl = _.omit(parsedQuery, 'page', 'size', 'descendants_welds', 'sort_by', 'sort_dir', '')

    // Konwertuj empty_* flagi z URL z string na boolean
    ;['empty_weld_type', 'empty_material_1', 'empty_material_2', 'empty_inspection_category', 'empty_wps', 'empty_welding_consumables', 'empty_welding_wps', 'blocked_for_import', 'has_attachments', 'dimensional_control'].forEach(key => {
      if (filtersFromUrl[key] !== undefined) filtersFromUrl[key] = filtersFromUrl[key] === 'true'
    })

    // Parsuj extra_data z URL z JSON string na obiekt
    if (filtersFromUrl.extra_data && typeof filtersFromUrl.extra_data === 'string') {
      try { filtersFromUrl.extra_data = JSON.parse(filtersFromUrl.extra_data) } catch (e) { delete filtersFromUrl.extra_data }
    }

    // Parsuj inspections z URL z JSON string na obiekt
    if (filtersFromUrl.inspections && typeof filtersFromUrl.inspections === 'string') {
      try { filtersFromUrl.inspections = JSON.parse(filtersFromUrl.inspections) } catch (e) { delete filtersFromUrl.inspections }
    }

    // Parsuj inspection_grouping z URL z JSON string na obiekt
    if (filtersFromUrl.inspection_grouping && typeof filtersFromUrl.inspection_grouping === 'string') {
      try { filtersFromUrl.inspection_grouping = JSON.parse(filtersFromUrl.inspection_grouping) } catch (e) { delete filtersFromUrl.inspection_grouping }
    }

    // Konwertuj welding_consumables z URL na format {value, label}
    if (filtersFromUrl.welding_consumables && props.weldingConsumables) {
      const ids = Array.isArray(filtersFromUrl.welding_consumables)
        ? filtersFromUrl.welding_consumables.map(id => Number(id))
        : [Number(filtersFromUrl.welding_consumables)]

      filtersFromUrl.welding_consumables = ids.map(id => {
        const consumable = props.weldingConsumables.find(c => Number(c.id) === id)
        return consumable ? { value: id, label: consumable.name } : { value: id, label: `ID: ${id}` }
      })
    }

    this.state = {
      screenHeight: window.innerHeight,
      welds: [],
      filters: filtersFromUrl,
      metadata: { next_page: null },
      weldsRowIdxToRemove: [],
      weldsRowIdxToRemovePermanently: [],
      validationErrors: null,
      weldingModal: false,
      inspectionModal: false,
      LogModalWeldIdx: null,
      LogModalWeldInspId: null,
      selectedIndexes: [],
      gridUpdatedRow: false,
      include_project_descendants_welds: parsedQuery.descendants_welds === 'true',
      base_material_modal_column: null,
      rowToUpdateIdx: null,
      wpsModal: false,
      inspectionCategoryModal: false,
      weldTypeModal: false,
      sortColumn: parsedQuery.sort_by || null,
      sortDirection: parsedQuery.sort_dir || null
    }

    this.getGridColumns = getGridColumns.bind(this)
    this.rowGetter = this.rowGetter.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.runWeldsFilter = this.runWeldsFilter.bind(this)
    this.openBaseMaterialModal = this.openBaseMaterialModal.bind(this)
    this.baseMaterialOnCommit = this.baseMaterialOnCommit.bind(this)

    this.handleFilterInUrl = this.handleFilterInUrl.bind(this)
    this.closeConfirmAlert = this.closeConfirmAlert.bind(this)
    this.removeWelds = this.removeWelds.bind(this)
    this.closeConfirmPermanentAlert = this.closeConfirmPermanentAlert.bind(this)
    this.removePermanentlyWelds = this.removePermanentlyWelds.bind(this)
    this.addNewWeld = this.addNewWeld.bind(this)
    this.onUpdateHandler = this.onUpdateHandler.bind(this)
    this.validationAlertOnClose = this.validationAlertOnClose.bind(this)

    this.closeWeldingLog = this.closeWeldingLog.bind(this)
    this.closeInspectionLog = this.closeInspectionLog.bind(this)
    this.afterSubmitWelding = this.afterSubmitWelding.bind(this)
    this.afterSubmitInspection = this.afterSubmitInspection.bind(this)
    this.componentWillReceiveProps = componentWillReceiveProps.bind(this)
    this.prepareWelds = prepareWelds.bind(this)
    this.multiLogsButtons = multiLogsButtons.bind(this)
    this.handleGridSort = this.handleGridSort.bind(this)
    this.updateDimensions = this.updateDimensions.bind(this)
    this.onBlockToggleHandler = this.onBlockToggleHandler.bind(this)

    this.canvas = null

    if (this.props.data && this.props.data.welds) {
      this.state.welds = this.prepareWelds(this.props.data.welds.list)
      this.state.metadata = this.props.data.welds.metadata
    }
  }

  static propTypes = {
    parentElement: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    loadFilterWelds: PropTypes.func.isRequired,
    loadPage: PropTypes.func.isRequired,
    destroyWeld: PropTypes.func.isRequired,
    createOrUpdateWeld: PropTypes.func.isRequired,
    projectId: PropTypes.number.isRequired,
    inspCatList: PropTypes.array.isRequired,
    inspCatTypesDict: PropTypes.array.isRequired,
    wpsList: PropTypes.array.isRequired,
    weldingConsumables: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    extraColumns: PropTypes.object.isRequired,
    weldTypeDict: PropTypes.array.isRequired,
    weldNumericFilterValues: PropTypes.object,
    getSelectedWeldIds: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    userColumnConfig: PropTypes.object
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    this.canvas = findDOMNode(this).querySelector('.react-grid-Canvas')
    this.canvas.addEventListener('scroll', this.onScroll)
    window.addEventListener('openBaseMaterialModal', this.openBaseMaterialModal)
    window.addEventListener('resize', this.updateDimensions)
    this.grid.onToggleFilter()
  }

  componentWillUnmount() {
    if (this.canvas) {
      this.canvas.removeEventListener('scroll', this.onScroll)
    }
    window.removeEventListener('openBaseMaterialModal', this.openBaseMaterialModal)
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions() {
    this.setState({ screenHeight: window.innerHeight })
  }

  runWeldsFilter() {
    this.setState({ selectedIndexes: [] })
    this.props.data.refetch({
      project_id: this.props.data.variables.project_id,
      include_project_descendants_welds: this.state.include_project_descendants_welds,
      filters: { 
        ...this.state.filters, 
        inspections: JSON.stringify(this.state.filters.inspections),
        inspection_grouping: JSON.stringify(this.state.filters.inspection_grouping),
        extra_data: JSON.stringify(this.state.filters.extra_data),
        sort_by: this.state.sortColumn,
        sort_dir: this.state.sortDirection
      }
    })
  }

  openBaseMaterialModal(e) {
    this.setState({ base_material_modal_column: e.detail.column_key })
  }

  baseMaterialOnCommit(val) {
    this.handleGridRowsUpdated({
      fromRow: this.state.rowToUpdateIdx, toRow: this.state.rowToUpdateIdx,
      updated: { [this.state.base_material_modal_column]: val }
    })
    this.setState({ base_material_modal_column: null, rowToUpdateIdx: null })
  }

  closeWeldingLog() {
    this.setState({
      weldingModal: false,
      LogModalWeldIdx: null
    })
  }

  closeWpsModal() {
    this.setState({
      wpsModal: false,
      LogModalWeldIdx: null
    })
  }

  closeInspectionLog() {
    this.setState({
      inspectionModal: false,
      LogModalWeldIdx: null,
      LogModalWeldInspId: null
    })
  }

  afterSubmitWelding() {
    let self = this

    function updateWeldingProgress(logsArr) {
      let newWelds = self.state.welds
      ;(self.state.LogModalWeldIdx || []).forEach((WeldIdx, i) => {
        newWelds[WeldIdx].welding_progress = logsArr[i].weld.welding_progress
        newWelds[WeldIdx].status = logsArr[i].weld.status
        newWelds[WeldIdx].welder = logsArr[i].weld.welder
      })

      self.setState({ weldingModal: false, welds: newWelds, LogModalWeldIdx: null })
    }

    return updateWeldingProgress
  }

  afterSubmitInspection() {
    let self = this

    function updateWeldingProgress(logsArr, file_url = null) {
      if (!logsArr || logsArr.length === 0) return

      let newWelds = self.state.welds
      ;(self.state.LogModalWeldIdx || []).map(idx => self.state.welds[idx]).forEach((weld, i) => {
        let newWeldData = (logsArr.find(o => o.weld && String(o.weld.id) === String(weld.id)) || {}).weld
        if (!newWeldData) return
        let weldIdx = self.state.LogModalWeldIdx[i]
        newWelds[weldIdx].welding_progress = newWeldData.welding_progress
        newWelds[weldIdx].status = newWeldData.status

        let inspections = typeof newWeldData.inspections === 'string' ? JSON.parse(newWeldData.inspections) : newWeldData.inspections
        if (inspections && inspections[self.state.LogModalWeldInspId]) {
          inspections[self.state.LogModalWeldInspId].file_url = file_url
        }
        newWelds[weldIdx].inspections = inspections
      })

      // update skipped welds from group
      const handledIds = new Set((self.state.LogModalWeldIdx || []).map(idx => String(self.state.welds[idx].id)))
      logsArr.forEach(logEntry => {
        if (!logEntry.weld || handledIds.has(String(logEntry.weld.id))) return
        const weldIdx = newWelds.findIndex(w => String(w.id) === String(logEntry.weld.id))
        if (weldIdx === -1) return
        const newWeldData = logEntry.weld
        newWelds[weldIdx].welding_progress = newWeldData.welding_progress
        newWelds[weldIdx].status = newWeldData.status
        newWelds[weldIdx].inspections = typeof newWeldData.inspections === 'string' ? JSON.parse(newWeldData.inspections) : newWeldData.inspections
        newWelds[weldIdx].inspection_groups = newWeldData.inspection_groups ? JSON.parse(newWeldData.inspection_groups) : {}
      })

      self.setState({ welds: newWelds, inspectionModal: false, LogModalWeldIdx: null, LogModalWeldInspId: null })
    }

    return updateWeldingProgress
  }

  closeConfirmAlert() {
    this.setState({ weldsRowIdxToRemove: [] })
  }

  closeConfirmPermanentAlert() {
    this.setState({ weldsRowIdxToRemovePermanently: [] })
  }

  removePermanentlyWelds() {
    let rowsData = []
    this.state.weldsRowIdxToRemovePermanently.forEach(idx => {
      rowsData.push(this.state.welds[idx])
    })

    let idsToDestroy = rowsData.map(o => o.id && o.id).filter(Boolean)
    if (idsToDestroy.length > 0) {
      this.props.destroyWeld({ variables: { ids: idsToDestroy, permanent: true } }).then(() => {
        // Usuń spoiny z lokalnego stanu po pomyślnym usunięciu
        let newWelds = this.state.welds.filter((weld, idx) => !this.state.weldsRowIdxToRemovePermanently.includes(idx))
        this.setState({ welds: newWelds, weldsRowIdxToRemovePermanently: [], selectedIndexes: [] })
      })
    }
  }

  validationAlertOnClose() {
    this.setState({ validationErrors: null })
  }

  removeWelds() {
    let newWelds = [...this.state.welds]
    let rowsData = []
    this.state.weldsRowIdxToRemove.forEach(idx => {
      newWelds[idx] = { ...newWelds[idx], status: 'removed' }
      rowsData.push(this.state.welds[idx])
    })
    this.setState({ welds: newWelds, weldsRowIdxToRemove: [] })

    let idsToDestroy = rowsData.map(o => o.id && o.id).filter(Boolean)
    if (idsToDestroy.length > 0) {
      this.props.destroyWeld({ variables: { ids: idsToDestroy } })
    }
  }

  onUpdateHandler(rowsIdx) {
    this.setState({ gridUpdatedRow: true })
    this.sendSaveWeldRequest(rowsIdx)
  }

  onBlockToggleHandler(rowIdx) {
    const weld = this.state.welds[rowIdx]
    if (!weld || !weld.id) return
    this.props.toggleBlockWeld({ variables: { id: weld.id } }).then(({ data: { toggleBlockWeld } }) => {
      if (toggleBlockWeld.errors === null) {
        let newWelds = [...this.state.welds]
        newWelds[rowIdx] = { ...newWelds[rowIdx], blocked_for_import: toggleBlockWeld.weld.blocked_for_import }
        this.setState({ welds: newWelds })
      }
    })
  }

  sendSaveWeldRequest(rowsIdx) {
    let idx = rowsIdx.shift()
    this.saveWeldRequest(this.state.welds[idx]).then(({ data: { createOrUpdateWelds } }) => {
      if (createOrUpdateWelds.errors === null) {
        // withGaEvent({category: 'New weld', action: 'save'}) // GA EVENT
        let newWelds = this.state.welds
        newWelds[idx].actions.save = false
        newWelds[idx]['id'] = createOrUpdateWelds.weld.id
        newWelds[idx]['project'] = createOrUpdateWelds.weld.project
        newWelds[idx]['status'] = createOrUpdateWelds.weld.status
        newWelds[idx]['wps'] = createOrUpdateWelds.weld.wps
        newWelds[idx]['weld_type'] = createOrUpdateWelds.weld.weld_joint_type
        newWelds[idx]['weld_joint_type'] = createOrUpdateWelds.weld.weld_joint_type
        this.setState({ welds: newWelds, validationErrors: null })
        if (rowsIdx.length > 0) {
          this.sendSaveWeldRequest(rowsIdx)
        }
        else {
          this.setState({ gridUpdatedRow: false })
        }
      }
      else {
        // withGaEvent({category: 'New weld', action: 'error save'}) // GA EVENT
        this.setState({ validationErrors: createOrUpdateWelds.errors, gridUpdatedRow: false })
      }
    })
  }

  async saveWeldRequest(rowData) {
    // Przekształć weld_joint_type z formatu GraphQL na format InputType
    let weldJointTypeInput = null
    if (rowData.weld_joint_type && Array.isArray(rowData.weld_joint_type)) {
      weldJointTypeInput = rowData.weld_joint_type.map(wjt => {
        if (wjt.weld_type && typeof wjt.weld_type === 'object') {
          // Format GraphQL - przekształć na format InputType
          return {
            weld_type_id: Number(wjt.weld_type.id),
            joint_type_id: wjt.joint_type ? Number(wjt.joint_type.id) : null
          }
        } else {
          // Format już jest InputType lub lokalny
          return {
            weld_type_id: Number(wjt.weld_type_id || wjt.weld_type),
            joint_type_id: wjt.joint_type_id ? Number(wjt.joint_type_id) : null
          }
        }
      })
    }

    return await this.props.createOrUpdateWeld({
      variables: {
        id: rowData.id ? Number(rowData.id) : null,
        project_id: rowData.id ? Number(rowData.project.id) : this.props.projectId,
        no: rowData.no,
        weld_joint_type: weldJointTypeInput,
        length: Number(rowData.length),
        thickness_1: Number(rowData.thickness_1),
        thickness_2: Number(rowData.thickness_2),
        material_1_id: rowData.material_1 ? Number(rowData.material_1.id) : null,
        material_2_id: rowData.material_2 ? Number(rowData.material_2.id) : null,
        diameter_1: rowData.diameter_1 ? Number(rowData.diameter_1) : null,
        diameter_2: rowData.diameter_2 ? Number(rowData.diameter_2) : null,
        wps_id: rowData.wps ? (Array.isArray(rowData.wps) ? rowData.wps.map(w => Number(w.id || w)) : [Number(rowData.wps)]) : null,
        inspection_category_id: rowData.inspection_category ? Number(rowData.inspection_category) : null,
        extra_data: JSON.stringify(_.pick(rowData, Object.keys(this.props.extraColumns)))
      }
    })
  }

  addNewWeld() {
    let newWelds = this.state.welds
    let newWeld = {
      no: '',
      weld_type: '',
      length: null,
      thickness_1: null,
      thickness_2: null,
      material_1: '',
      material_2: '',
      diameter_1: '',
      diameter_2: '',
      wps: '',
      inspection_category: '',
      actions: { save: true }
    }

    newWelds.splice(0, 0, newWeld)
    let newSelectedIndexes = this.state.selectedIndexes.map(o => o + 1)
    this.setState({ welds: newWelds, selectedIndexes: newSelectedIndexes })
  }

  rowGetter(i) {
    const row = this.state.welds[i];
    if (!row) return null;
    return {
      ...row,
      extraClasses: row.status === 'removed' ? 'removed-row' : null
    };
  }

  onScroll() {
    if (((this.canvas.scrollHeight - (this.canvas.scrollTop + this.canvas.clientHeight)) < (this.canvas.clientHeight * 3)) && !this.loadingMore) {
      if (!this.loadingMore && this.state.metadata.next_page) {
        this.loadingMore = true
        const filtersWithSort = {
          ...this.state.filters,
          sort_by: this.state.sortColumn,
          sort_dir: this.state.sortDirection
        }
        this.props.loadPage(
          this.props.data.variables.project_id, this.state.include_project_descendants_welds, this.state.metadata.next_page, filtersWithSort
        ).then(() => {
          this.loadingMore = false
        })
      }
    }
  }

  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    let rows = this.state.welds.slice()

    for (let i = fromRow; i <= toRow; i++) {
      let updatedRow = { ...rows[i], ...updated }
      if (!_.isEqual(rows[i], updatedRow)) {
        updatedRow.actions.save = true
        rows[i] = updatedRow
      }
    }

    this.setState({ welds: rows, rowToUpdateIdx: fromRow })
  }

  handleFilterChange = (filter) => {
    let newFilters = this.state.filters
    let inspDateMatch = /^\$inspections_(\d+)_date$/.exec(filter.column.key)
    let inspReportNoMatch = /^\$inspections_(\d+)_report_no$/.exec(filter.column.key)
    let inspGroupingMatch = /^\$inspections_(\d+)_grouping$/.exec(filter.column.key)
    let inspId = !inspDateMatch && !inspReportNoMatch && !inspGroupingMatch && /\$inspections_\d+/.test(filter.column.key) ? filter.column.key.slice(13) : null
    let isItExtraData = Object.keys(this.props.extraColumns).includes(filter.column.key)

    if (filter.filterTerm) {
      if (inspDateMatch) {
        const id = inspDateMatch[1]
        if (typeof newFilters.inspections === 'string') newFilters.inspections = JSON.parse(newFilters.inspections) || {}
        newFilters.inspections === undefined && (newFilters.inspections = {})
        newFilters.inspections[id] === undefined && (newFilters.inspections[id] = {})
        filter.rawValue.from ? newFilters.inspections[id].date_from = filter.rawValue.from : delete newFilters.inspections[id].date_from
        filter.rawValue.to ? newFilters.inspections[id].date_to = filter.rawValue.to : delete newFilters.inspections[id].date_to
      }
      else if (inspReportNoMatch) {
        const id = inspReportNoMatch[1]
        if (typeof newFilters.inspections === 'string') newFilters.inspections = JSON.parse(newFilters.inspections) || {}
        newFilters.inspections === undefined && (newFilters.inspections = {})
        newFilters.inspections[id] === undefined && (newFilters.inspections[id] = {})
        newFilters.inspections[id].report_no = filter.filterTerm
      }
      else if (inspGroupingMatch) {
        const id = inspGroupingMatch[1]
        const selectedValues = filter.filterTerm.map(o => o.value)
        newFilters.inspection_grouping === undefined && (newFilters.inspection_grouping = {})
        selectedValues.length > 0 ? newFilters.inspection_grouping[id] = selectedValues : delete newFilters.inspection_grouping[id]
      }
      else if (inspId) {
        if (typeof newFilters.inspections === 'string') newFilters.inspections = JSON.parse(newFilters.inspections) || {}
        newFilters.inspections === undefined && (newFilters.inspections = {})
        let inspFilterVal = filter.filterTerm.map(o => o.value)
        inspFilterVal.length > 0 ? newFilters.inspections[inspId] = inspFilterVal : delete newFilters.inspections[inspId]
      }
      else if (isItExtraData) {
        newFilters.extra_data === undefined && (newFilters.extra_data = {})
        newFilters.extra_data[filter.column.key] = filter.filterTerm
      }
      else if (filter.column.key === 'weld_type') {
        const emptySelected = filter.filterTerm.find(o => o.value === '__')
        if (emptySelected) {
          newFilters['empty_weld_type'] = true
          const rest = filter.filterTerm.filter(o => o.value !== '__')
          rest.length > 0 ? newFilters['weld_joint_type'] = rest.map(o => o.value) : delete newFilters['weld_joint_type']
        } else {
          delete newFilters['empty_weld_type']
          newFilters['weld_joint_type'] = filter.filterTerm.map(o => o.value)
        }
      }
      else if (filter.column.key === 'no') {
        newFilters[filter.column.key] = filter.filterTerm
      }
      else if (filter.column.key === 'blocked_for_import') {
        const values = filter.rawValue && filter.rawValue.map(o => o.value)
        if (values && values.length === 1) {
          newFilters['blocked_for_import'] = values[0] === 'true'
        } else {
          delete newFilters['blocked_for_import']
        }
      }
      else if (filter.column.key === 'dimensional_control') {
        const values = filter.rawValue && filter.rawValue.map(o => o.value)
        if (values && values.length === 1) {
          newFilters['dimensional_control'] = values[0] === 'true'
        } else {
          delete newFilters['dimensional_control']
        }
      }
      else if (filter.column.key === 'last_welding_date' && filter.rawValue && typeof filter.rawValue === 'object') {
        filter.rawValue.from ? newFilters['last_welding_date_from'] = filter.rawValue.from : delete newFilters['last_welding_date_from']
        filter.rawValue.to ? newFilters['last_welding_date_to'] = filter.rawValue.to : delete newFilters['last_welding_date_to']
      }
      else {
        let isArray = Array.isArray(filter.rawValue)
        if (isArray && filter.rawValue.find(o => o.value === '__')) {
          const col = filter.column.key
          const emptyKey = `empty_${col}`
          newFilters[emptyKey] = true
          const rest = filter.rawValue.filter(o => o.value !== '__')
          rest.length > 0 ? newFilters[col] = rest.map(o => o.value) : delete newFilters[col]
        } else {
          newFilters[filter.column.key] = isArray ? filter.rawValue.map(o => o.value) : filter.rawValue || filter.filterTerm
        }
      }
    } else {
      if (inspDateMatch) {
        const id = inspDateMatch[1]
        if (newFilters.inspections && newFilters.inspections[id]) {
          delete newFilters.inspections[id].date_from
          delete newFilters.inspections[id].date_to
        }
      }
      else if (inspReportNoMatch) {
        const id = inspReportNoMatch[1]
        if (newFilters.inspections && newFilters.inspections[id]) {
          delete newFilters.inspections[id].report_no
        }
      }
      else if (inspGroupingMatch) {
        const id = inspGroupingMatch[1]
        if (newFilters.inspection_grouping) delete newFilters.inspection_grouping[id]
      }
      else if (filter.column.key === 'last_welding_date') {
        delete newFilters['last_welding_date_from']
        delete newFilters['last_welding_date_to']
      }
      else if (filter.column.key === 'blocked_for_import') {
        delete newFilters['blocked_for_import']
      }
      else if (filter.column.key === 'dimensional_control') {
        delete newFilters['dimensional_control']
      }
      else if (filter.column.key === 'weld_type') {
        delete newFilters['weld_joint_type']
        delete newFilters['empty_weld_type']
      }
      else if (['material_1', 'material_2', 'inspection_category', 'wps', 'welding_wps'].includes(filter.column.key)) {
        delete newFilters[filter.column.key]
        delete newFilters[`empty_${filter.column.key}`]
      }
      else if (isItExtraData) {
        delete newFilters.extra_data[filter.column.key]
      }
      else {
        delete newFilters[filter.column.key]
      }
    }

    this.setState({ filters: newFilters })
  }

  getValidFilterValues = (columnKey) => {
    const groupingMatch = /^\$inspections_(\d+)_grouping$/.exec(columnKey)
    if (groupingMatch) {
      const inspId = groupingMatch[1]
      const allGroups = (this.props.allInspectionGroups && this.props.allInspectionGroups.weld_inspection_groups) || []
      const groupIds = allGroups
        .filter(g => String(g.inspection_category_type_id) === String(inspId))
        .map(g => String(g.id))
        .sort((a, b) => Number(a) - Number(b))
      return [
        { value: 'single', label: 'single' },
        ...groupIds.map(gid => ({ value: `Group id ${gid}`, label: `Group id ${gid}` }))
      ]
    }

    if (/\$inspections_\d*/.test(columnKey)) {
      return ['positive', 'failed', 'failed_anytime', 'required', 'not_required', 'skipped']
    }

    switch (columnKey) {
      case 'welding_progress':
        return ['done', 'in_progress', 'not_started']
      case 'dimensional_control':
        return [{ value: 'true', label: 'Yes' }, { value: 'false', label: 'No' }]
      case 'status':
        return ['new', 'ready', 'in_progress', 'ok', 'attachments_incomplete', 'failed', 'inconsistent']
      case 'blocked_for_import':
        return [{ value: 'true', label: 'Blocked' }, { value: 'false', label: 'Not blocked' }]
      case 'wps':
        return [{ value: '__', label: '- empty -' }, ...this.props.wpsList.map(obj => ({ value: Number(obj.id), label: `${obj.no}(${obj.rev_no})` }))]
      case 'inspection_category':
        return [{ value: '__', label: '- empty -' }, ...this.props.inspCatList.map(obj => ({ value: Number(obj.id), label: obj.name }))]
      case 'welder':
        return [{ value: '__', label: '- empty -' }, ...this.weldsWeldersForFilterSelect()]
      case 'welding_consumables':
        return [{ value: '__', label: '- empty -' }, ...(this.props.weldingConsumables ? this.props.weldingConsumables.map(obj => ({ value: Number(obj.id), label: obj.name })) : [])]
      case 'welding_wps':
        return [{ value: '__', label: '- empty -' }, ...this.weldsWeldingWpsForFilterSelect()]
      case 'length':
      case 'diameter_1':
      case 'thickness_1':
      case 'diameter_2':
      case 'thickness_2': {
        const vals = (this.props.weldNumericFilterValues || {})[columnKey] || []
        return vals.map(v => ({ value: v, label: v }))
      }
      case 'material_1':
      case 'material_2':
        return [{ value: '__', label: '- empty -' }, ...this.weldsMaterialsForFilterSelect()]
      case 'weld_type':
        return [{ value: '__', label: '- empty -' }, ...this.props.weldTypeDict]
      default:
        return []
    }
  }

  weldsWeldersForFilterSelect() {
    let welders = []
    this.state.welds.map(weld => (
      weld.welder && weld.welder.person && welders.push({ value: Number(weld.welder.person.id), label: weld.welder.person.last_name })
    ))
    return _.uniqBy(welders, (o) => o.value)
  }

  weldsMaterialsForFilterSelect() {
    let materials = []
    this.state.welds.forEach(weld => {
      weld.material_1 && materials.push({ value: weld.material_1.id, label: weld.material_1.designation_name })
      weld.material_2 && materials.push({ value: weld.material_2.id, label: weld.material_2.designation_name })
    })
    return _.uniqBy(materials, (o) => o.value)
  }

  weldsWeldingWpsForFilterSelect() {
    let wpsNumbers = []
    this.state.welds.forEach(weld => {
      if (weld.welder && weld.welder.wps_no) {
        weld.welder.wps_no.split(', ').forEach(wpsNo => {
          wpsNumbers.push({ value: wpsNo.trim(), label: wpsNo.trim() })
        })
      }
    })
    return _.uniqBy(wpsNumbers, (o) => o.value)
  }

  handleOnClearFilters = () => {
    this.setState({ filters: {} })
  }

  onRowsSelected = (welds) => {
    this.setState({ selectedIndexes: this.state.selectedIndexes.concat(welds.map(r => r.rowIdx)) })
  }

  onRowsDeselected = (welds) => {
    let rowIndexes = welds.map(r => r.rowIdx)
    this.setState({ selectedIndexes: this.state.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1) })
  }

  pageUrlParam() {
    let parsed_search = queryString.parse(this.props.history.location.search)
    return parsed_search.page ? `page=${parsed_search.page}&` : ''
  }

  handleOnClearFilters = () => {
    this.setState({ filters: {}, sortColumn: null, sortDirection: null }, () => {
      this.props.loadFilterWelds(this.props.data.variables.project_id, this.state.include_project_descendants_welds, this.state.filters)
    })
    this.props.history.push(`${this.props.history.location.pathname}?${this.pageUrlParam()}`)
  }

  handleFilterInUrl() {
    let filtersForUrl = { ...this.state.filters }

    // Konwertuj welding_consumables z {value, label} na same ID
    if (filtersForUrl.welding_consumables && Array.isArray(filtersForUrl.welding_consumables)) {
      filtersForUrl.welding_consumables = filtersForUrl.welding_consumables.map(item => item.value || item)
    }

    let newFilter = queryString.stringify({
      ...filtersForUrl,
      inspections: JSON.stringify(filtersForUrl.inspections),
      inspection_grouping: JSON.stringify(filtersForUrl.inspection_grouping),
      extra_data: JSON.stringify(filtersForUrl.extra_data),
      descendants_welds: this.state.include_project_descendants_welds,
      sort_by: this.state.sortColumn,
      sort_dir: this.state.sortDirection
    })
    this.props.history.push(`${this.props.history.location.pathname}?${this.pageUrlParam()}${newFilter}`)
  }

  handleGridSort(sortColumn, sortDirection) {
    const newSortColumn = sortDirection === 'NONE' ? null : sortColumn
    const newSortDirection = sortDirection === 'NONE' ? null : sortDirection
    this.setState({ sortColumn: newSortColumn, sortDirection: newSortDirection }, () => {
      this.runWeldsFilter()
      this.handleFilterInUrl()
    })
  }

  render() {
    const rowText = this.state.selectedIndexes.length === 1 ? 'row' : 'rows'
    return (
      <BlockWithLoader loading={this.props.data.loading} renderChildren={true}>
        {this.state.base_material_modal_column &&
          <BaseMaterialModal
            onCancel={() => this.setState({ base_material_modal_column: null, rowToUpdateIdx: null })}
            afterSubmit={this.baseMaterialOnCommit}
            disableUpdateStore={true}
          />}
        {this.state.validationErrors &&
          <ValidationAlert messages={this.state.validationErrors} onClose={this.validationAlertOnClose} />}

        <ConfirmModal
          isOpened={!!this.state.weldsRowIdxToRemove.length}
          onCancel={this.closeConfirmAlert}
          onConfirm={this.removeWelds}
          headerText='Remove Weld'
          bodyText='Are you sure you want to remove this weld?'
          confirmBtnText='Remove'
        />

        <ConfirmModal
          isOpened={!!this.state.weldsRowIdxToRemovePermanently.length}
          onCancel={this.closeConfirmPermanentAlert}
          onConfirm={this.removePermanentlyWelds}
          headerText='Delete Weld Permanently'
          bodyText='Are you sure you want to permanently delete this weld? This action cannot be undone!'
          confirmBtnText='Delete Permanently'
        />

        {this.state.weldingModal &&
          <WeldingLogModal
            isOpened={this.state.weldingModal}
            onCancel={this.closeWeldingLog}
            afterSubmit={this.afterSubmitWelding()}
            weldsData={this.state.LogModalWeldIdx.map(idx => this.state.welds[idx])}
          />
        }
        {this.state.inspectionModal &&
          <InspectionLogModal
            isOpened={this.state.inspectionModal}
            onCancel={this.closeInspectionLog}
            afterSubmit={this.afterSubmitInspection()}
            weldsData={this.state.LogModalWeldIdx.map(idx => this.state.welds[idx])}
            weldInspCat={this.props.inspCatList.find(inspCat => String(inspCat.id) === String(this.state.welds[this.state.LogModalWeldIdx[0]].inspection_category))}
            inspCatTypesDict={this.props.inspCatTypesDict}
            LogModalWeldInspId={Number(this.state.LogModalWeldInspId)}
            groupInspectionData={(() => {
              const weld = this.state.welds[this.state.LogModalWeldIdx[0]]
              const inspId = Number(this.state.LogModalWeldInspId)
              if (!weld || !weld.inspection_groups) return null
              const entry = Object.values(weld.inspection_groups).find(g => Number(g.insp_cat_type_id) === inspId)
              return (entry && entry.representative) ? entry : null
            })()}
          />
        }

        {this.state.wpsModal &&
          <WpsModal
            onCancel={() => this.setState({ wpsModal: false, LogModalWeldIdx: null })}
            onSubmit={(wps_array, selectedWelds) => {
              let weldsWithWps = this.state.welds
              if (selectedWelds) {
                // Multiple welds
                selectedWelds.forEach(weld => {
                  let weldIdx = weldsWithWps.findIndex(w => w.id === weld.id)
                  if (weldIdx !== -1) {
                    weldsWithWps[weldIdx].wps = wps_array && wps_array.length > 0 ? wps_array : null
                    weldsWithWps[weldIdx].actions = { save: true }
                  }
                })
              } else {
                // Single weld (fallback)
                weldsWithWps[this.state.LogModalWeldIdx[0]].wps = wps_array && wps_array.length > 0 ? wps_array : null
                weldsWithWps[this.state.LogModalWeldIdx[0]].actions = { save: true }
              }
              this.setState({ welds: weldsWithWps, wpsModal: false, LogModalWeldIdx: null })
            }}
            weldData={Array.isArray(this.state.LogModalWeldIdx) && typeof this.state.LogModalWeldIdx[0] === 'object' ? this.state.LogModalWeldIdx : this.state.welds[this.state.LogModalWeldIdx[0]]}
            project_id={this.props.projectId}
          />
        }

        {this.state.wpsViewModalId &&
          <WpsViewModal
            wpsId={this.state.wpsViewModalId}
            onClose={() => this.setState({ wpsViewModalId: null })}
          />
        }

        {this.state.inspectionCategoryModal &&
          <InspectionCategoryModal
            onCancel={() => this.setState({ inspectionCategoryModal: false, LogModalWeldIdx: null })}
            onSubmit={(inspection_category_id, selectedWelds) => {
              let weldsWithInspCat = this.state.welds
              if (selectedWelds) {
                // Multiple welds
                selectedWelds.forEach(weld => {
                  let weldIdx = weldsWithInspCat.findIndex(w => w.id === weld.id)
                  if (weldIdx !== -1) {
                    weldsWithInspCat[weldIdx].inspection_category = inspection_category_id
                    weldsWithInspCat[weldIdx].actions = { save: true }
                  }
                })
              }
              this.setState({ welds: weldsWithInspCat, inspectionCategoryModal: false, LogModalWeldIdx: null })
            }}
            weldData={Array.isArray(this.state.LogModalWeldIdx) && typeof this.state.LogModalWeldIdx[0] === 'object' ? this.state.LogModalWeldIdx : this.state.welds[this.state.LogModalWeldIdx[0]]}
            inspCatList={this.props.inspCatList}
          />
        }

        {this.state.weldTypeModal &&
          <WeldTypeModal
            onCancel={() => this.setState({ weldTypeModal: false, LogModalWeldIdx: null })}
            onSubmit={(weldJointTypes, selectedWelds) => {
              let weldsWithWeldType = this.state.welds

              // Buduj obiekt w formacie GraphQL jak z serwera
              const graphqlFormatWeldTypes = weldJointTypes.map(wjt => {
                const weldTypeEntry = this.props.weldTypeDict.find(w => {
                  const [weldId, jointId] = w.value.split('-')
                  return weldId == wjt.weld_type_id && (wjt.joint_type_id ? jointId == wjt.joint_type_id : !jointId)
                })

                let weldTypeName, jointTypeName
                if (weldTypeEntry) {
                  // Użyj tej samej logiki co w getGridColumns formatter
                  const parts = weldTypeEntry.text.split('-')
                  if (parts.length >= 2 && wjt.joint_type_id) {
                    weldTypeName = parts.slice(0, -1).join('-') // Wszystko oprócz ostatniej części
                    jointTypeName = parts[parts.length - 1] // Ostatnia część
                  } else {
                    weldTypeName = weldTypeEntry.text
                    jointTypeName = null
                  }
                } else {
                  weldTypeName = `WeldType_${wjt.weld_type_id}`
                  jointTypeName = wjt.joint_type_id ? `JointType_${wjt.joint_type_id}` : null
                }

                return {
                  weld_type: {
                    id: wjt.weld_type_id,
                    name: weldTypeName,
                    __typename: 'Dictionary'
                  },
                  joint_type: wjt.joint_type_id ? {
                    id: wjt.joint_type_id,
                    name: jointTypeName,
                    __typename: 'Dictionary'
                  } : null,
                  __typename: 'WeldJoinOutputType'
                }
              })

              if (selectedWelds) {
                selectedWelds.forEach(weld => {
                  let weldIdx = weldsWithWeldType.findIndex(w => w.id === weld.id)
                  if (weldIdx !== -1) {
                    weldsWithWeldType[weldIdx].weld_joint_type = weldJointTypes
                    weldsWithWeldType[weldIdx].weld_type = graphqlFormatWeldTypes
                    weldsWithWeldType[weldIdx].actions = { save: true }
                  }
                })
              } else {
                weldsWithWeldType[this.state.LogModalWeldIdx[0]].weld_joint_type = weldJointTypes
                weldsWithWeldType[this.state.LogModalWeldIdx[0]].weld_type = graphqlFormatWeldTypes
                weldsWithWeldType[this.state.LogModalWeldIdx[0]].actions = { save: true }
              }
              this.setState({ welds: weldsWithWeldType, weldTypeModal: false, LogModalWeldIdx: null })
            }}
            weldData={Array.isArray(this.state.LogModalWeldIdx) && typeof this.state.LogModalWeldIdx[0] === 'object' ? this.state.LogModalWeldIdx : this.state.welds[this.state.LogModalWeldIdx && this.state.LogModalWeldIdx[0]]}
            weldTypeDict={this.props.weldTypeDict}
          />
        }

        <div className="float-left"> Show welds from all elements &nbsp;
          <Label id="show-welds-switch" className="switch switch-sm switch-text switch-info float-right mb-0">
            <Input type="checkbox" className="switch-input"
              defaultChecked={this.state.include_project_descendants_welds}
              onChange={() => {
                const newValue = !this.state.include_project_descendants_welds
                this.props.loadFilterWelds(this.props.data.variables.project_id, newValue, this.state.filters)
                this.props.onDescendantsChange && this.props.onDescendantsChange(newValue)
                this.setState({
                  include_project_descendants_welds: newValue,
                  selectedIndexes: []
                }, () => this.handleFilterInUrl())
              }
              } />
            <span className="switch-label" data-on="On" data-off="Off" />
            <span className="switch-handle" />
          </Label>
        </div>
        <span className="selectedRow" id="number-selected-rows">
          &nbsp; {this.state.selectedIndexes.length} {rowText} selected</span>
        <ReactDataGrid
          ref={(grid) => { this.grid = grid }}
          headerRowHeight={50}
          enableCellSelect={true}
          columns={this.getGridColumns(this.props, this.state)}
          rowGetter={this.rowGetter}
          rowsCount={this.state.welds.length}
          minHeight={this.state.screenHeight - 350}
          onGridSort={this.handleGridSort}
          sortColumn={this.state.sortColumn}
          sortDirection={this.state.sortDirection}
          toolbar={
            <Toolbar
              onAddRow={getUserPermissions('wl_welds.welds.create') && this.props.parentElement.company_permitted &&
                !this.state.include_project_descendants_welds && this.addNewWeld}>
              {this.multiLogsButtons()}
              {!_.isEmpty(this.state.filters) &&
                <Button id='clear-filters-welds-grid-btn' key='clear-filters-welds-grid-btn' onClick={() => {
                  this.grid.onToggleFilter()
                  setTimeout(() => this.grid.onToggleFilter(), 1)
                }} style={{ float: 'right' }}><i className="fa fa-eraser" /> Clear Filter
                </Button>}
              <Button id='filter-welds-grid-btn' key='filter-welds-grid-btn' style={{ float: 'right' }} onClick={() => {
                this.runWeldsFilter()
                this.handleFilterInUrl()
              }}>
                <i className="fa fa-filter" /> Filter
              </Button>
              <Button style={{ float: 'left' }} onClick={this.runWeldsFilter}>Refresh <i className="fa fa-refresh" /></Button>
              {getUserPermissions('wl_welds.welds.destroy') && this.state.selectedIndexes.length > 0 &&
                <Button style={{ float: 'left' }} onClick={() => this.setState({ weldsRowIdxToRemove: this.state.selectedIndexes })}>
                  Delete <i className="fa fa-trash" /></Button>}
              {getUserPermissions('wl_welds.permanent_deletion.welds') && this.state.selectedIndexes.length > 0 &&
                <Button style={{ float: 'left' }} onClick={() => this.setState({ weldsRowIdxToRemovePermanently: this.state.selectedIndexes })}>
                  Delete permanently <i className="fa fa-trash" /></Button>}
              {(getUserPermissions('wl_welds.welds.update') || getUserPermissions('wl_welds.welds.create')) &&
                this.state.welds.find(o => o.actions.save) && <Button style={{ float: 'left' }} onClick={() => {
                  this.onUpdateHandler(this.state.welds.map((o, idx) => o.actions.save && idx).filter(o => o !== false))
                }}>
                  Save all <i className="fa fa-save" />
                </Button>}
            </Toolbar>
          }
          onAddFilter={this.handleFilterChange}
          getValidFilterValues={this.getValidFilterValues}
          onClearFilters={this.handleOnClearFilters}
          onGridRowsUpdated={this.handleGridRowsUpdated}
          rowSelection={
            {
              showCheckbox: true,
              enableShiftSelect: false,
              onRowsSelected: this.onRowsSelected,
              onRowsDeselected: this.onRowsDeselected,
              selectBy: {
                indexes: this.state.selectedIndexes
              }
            }}
        />
      </BlockWithLoader>
    )
  }
}

const WeldsDataGridWithMutations = compose(
  graphql(WeldsFetchQuery, {
    options: (props) => {
      const parsedQuery = queryString.parse(props.history.location.search)
      let filtersFromUrl = _.omit(parsedQuery, 'page', 'size', 'descendants_welds', '')
      ;['empty_weld_type', 'empty_material_1', 'empty_material_2', 'empty_inspection_category', 'empty_wps', 'empty_welding_consumables', 'empty_welding_wps', 'blocked_for_import', 'has_attachments', 'dimensional_control'].forEach(key => {
        if (filtersFromUrl[key] !== undefined) filtersFromUrl[key] = filtersFromUrl[key] === 'true'
      })
      if (filtersFromUrl.extra_data && typeof filtersFromUrl.extra_data === 'string') {
        try { filtersFromUrl.extra_data = JSON.parse(filtersFromUrl.extra_data) } catch (e) { delete filtersFromUrl.extra_data }
      }
      if (filtersFromUrl.inspection_grouping && typeof filtersFromUrl.inspection_grouping === 'string') {
        try { filtersFromUrl.inspection_grouping = JSON.parse(filtersFromUrl.inspection_grouping) } catch (e) { delete filtersFromUrl.inspection_grouping }
      }
      if (filtersFromUrl.inspections && typeof filtersFromUrl.inspections === 'string') {
        try { filtersFromUrl.inspections = JSON.parse(filtersFromUrl.inspections) } catch (e) { delete filtersFromUrl.inspections }
      }
      return {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        variables: {
          project_id: props.projectId,
          include_project_descendants_welds: parsedQuery.descendants_welds === 'true',
          filters: {
            ...filtersFromUrl,
            inspection_grouping: filtersFromUrl.inspection_grouping ? JSON.stringify(filtersFromUrl.inspection_grouping) : undefined,
            inspections: filtersFromUrl.inspections ? JSON.stringify(filtersFromUrl.inspections) : undefined,
            extra_data: filtersFromUrl.extra_data ? JSON.stringify(filtersFromUrl.extra_data) : undefined
          }
        }
      }
    },
    props({ data: { loading, welds, variables, fetchMore, refetch } }) {
      return {
        data: {
          loading,
          welds,
          variables,
          refetch
        },
        loadPage(project_id, include_project_descendants_welds, page, filters) {
          return fetchMore({
            variables: {
              project_id: project_id,
              include_project_descendants_welds: include_project_descendants_welds,
              page: page,
              filters: { 
                ...filters, 
                inspections: JSON.stringify(filters.inspections),
                inspection_grouping: JSON.stringify(filters.inspection_grouping),
                extra_data: JSON.stringify(filters.extra_data)
              }
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              let newWelds = fetchMoreResult.welds
              newWelds.list = [...previousResult.welds.list, ...fetchMoreResult.welds.list]
              return { welds: newWelds }
            }
          })
        },
        loadFilterWelds(project_id, include_project_descendants_welds, filters) {
          return fetchMore({
            variables: {
              project_id: project_id,
              include_project_descendants_welds: include_project_descendants_welds,
              page: 1,
              filters: { 
                ...filters, 
                inspections: JSON.stringify(filters.inspections),
                inspection_grouping: JSON.stringify(filters.inspection_grouping),
                extra_data: JSON.stringify(filters.extra_data)
              }
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              return { welds: fetchMoreResult.welds }
            }
          })
        }
      }
    }
  }),
  graphql(createOrUpdateWeldsMutation, { name: 'createOrUpdateWeld' }),
  graphql(destroyWeldsMutation, { name: 'destroyWeld' }),
  graphql(toggleBlockWeldMutation, { name: 'toggleBlockWeld' }),
  graphql(WeldInspectionGroupsQuery, {
    name: 'allInspectionGroups',
    options: (props) => ({
      variables: { project_id: props.projectId },
      fetchPolicy: 'network-only'
    })
  })
)(WeldsDataGrid)

export default WeldsDataGridWithMutations



// WEBPACK FOOTER //
// ./src/components/Welds/WeldsDataGrid.js